import React from 'react'
import List from '../BaseAssetsList'
import Item from './ListItem'
import { HeaderContainer } from './HeaderContainer'
import { SOURCE_FILE_TYPES } from '~/enums'

export default function TextAssetsList(props) {
  return (
    <List
      {...props}
      header={<HeaderContainer type={SOURCE_FILE_TYPES.TEXT} />}
      ItemComponent={props => <Item {...props} />}
    />
  )
}
